import formatTableJson from '@/config/tableComponentParams.js'
import { enbaleDisableStatus } from '@/config/status'
export default formatTableJson([
  {
    filed: 'identifier',
    label: '账号'
  },
  {
    filed: 'name',
    label: '姓名'
  },
  {
    filed: 'state',
    label: '状态',
    type: 'status',
    statusProps: enbaleDisableStatus,
    formatFn: function(_, row) {
      return row.stateName
    }
  },
  {
    filed: 'dataType',
    label: '所属角色'
  },
  {
    filed: 'latestValue',
    label: '电话'
  },
  {
    filed: 'latestValue',
    label: '邮箱'
  }
])
